import { gql } from "@apollo/client";

export default gql`
  mutation updateAnnouncementCategory($input: UpdateChangelogCategoryInput!){
    updateAnnouncementCategory(input: $input){
        success
        data{
            _id
            color
            translations
            createdAt
            updatedAt
        }
        error
        message
    }
}
`
